import Glide from '@glidejs/glide'


if (document.querySelector('#ExpertQuotesGlide')) {
    const el = document.querySelector('#ExpertQuotesGlide');
    const expertQuoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 3,
        gap: 20,
        peek: {
            before: 250,
            after: 250,
        },
        breakpoints: {
            1400: {
                peek: {
                    before: 150,
                    after: 150,
                },
            },
            1200: {
                perView: 2,
            },
            1080: {
                peek: {
                    before: 80,
                    after: 80,
                },
            },
            992: {
                perView: 1,
                peek: {
                    before: 200,
                    after: 200,
                },
            },
            768: {
                perView: 1,
                peek: {
                    before: 100,
                    after: 100,
                },
            },
            576: {
                perView: 1,
                peek: {
                    before: 0,
                    after: 0,
                },
            },
        },
    });
    expertQuoteSlider.mount();
}
if (document.querySelector('#GovQuotesGlide')) {
    const el = document.querySelector('#GovQuotesGlide');
    const govQuoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 3,
        gap: 20,
        peek: {
            before: 250,
            after: 250,
        },
        breakpoints: {
            1400: {
                perView: 3,
                peek: {
                    before: 150,
                    after: 150,
                },
            },
            1200: {
                perView: 2,
            },
            1080: {
                perView: 2,
                peek: {
                    before: 80,
                    after: 80,
                },
            },
            992: {
                perView: 1,
                peek: {
                    before: 200,
                    after: 200,
                },
            },
            768: {
                perView: 1,
                peek: {
                    before: 100,
                    after: 100,
                },
            },
            576: {
                perView: 1,
                gap: 12,
                peek: {
                    before: 0,
                    after: 0,
                },
            },
        },
    });
    govQuoteSlider.mount();
}
